import { FC, useMemo } from "react";

import __ from "web/Layout/Translations";

import useFeatureFlag from "web/hooks/useFeatureFlag/useFeatureFlag";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import formatNumber from "web/utils/data/parser/number/formatNumber";

import FEATURE_FLAGS from "web/constants/featureFlags";

import { ICnsx } from "web/types/Tourism";

type CancellationPolicyOptionProps = Pick<ICnsx, "from" | "to" | "value"> & {
  className: string;
};
const CancellationPolicyOption: FC<CancellationPolicyOptionProps> = ({
  from,
  to,
  value,
  className,
}) => {
  const isFeatureFlagFR_1816 = useFeatureFlag(FEATURE_FLAGS.FR_1816);
  const { fromFormatted, toFormatted, valueFormatted } = useMemo(
    () => ({
      fromFormatted: formatDate(from),
      toFormatted: formatDate(to),
      valueFormatted: formatNumber(value),
    }),
    [from, to, value]
  );

  const [cancelText, toText, paymentText, currencyText, hourText] = useMemo(
    () => [
      __("Anulacja w terminach od"),
      __("do"),
      __("- zostaniesz obciążony kwotą anulacji w wysokości"),
      __("zł"),
      __("godz."),
    ],
    []
  );

  return (
    <p className={className}>
      {cancelText}&nbsp;
      {isFeatureFlagFR_1816 ? (
        <>{fromFormatted},&nbsp;</>
      ) : (
        <>{fromFormatted}&nbsp;</>
      )}
      {isFeatureFlagFR_1816 && <>{hourText}&nbsp;22:00&nbsp;</>}
      {toText}&nbsp;
      {isFeatureFlagFR_1816 ? (
        <>{toFormatted},&nbsp;</>
      ) : (
        <>{toFormatted}&nbsp;</>
      )}
      {isFeatureFlagFR_1816 && <>{hourText}&nbsp;21:59&nbsp;</>}
      {paymentText}&nbsp;
      {valueFormatted}&nbsp;
      {currencyText}&nbsp;
    </p>
  );
};

export default CancellationPolicyOption;
